"use client"

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { AccountSettingsTab } from "./account-settings-tab"
import { LoginSecurityTab } from "./login-security-tab"
import { NotificationsTab } from "./notifications-tab"
import { AdditionalSettingsTab } from "./additional-settings-tab"
import { BranchesTab } from "./branches-tab"
import { EducationSystemTab } from "./education-system-tab"
import { GameControlsTab } from "./game-controls-tab"

export function SettingsTabs() {
  return (
    <Tabs defaultValue="account" className="w-full">
      <TabsList className="flex flex-wrap gap-1 bg-muted p-1 h-auto">
        <TabsTrigger
          value="account"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Account
        </TabsTrigger>
        <TabsTrigger
          value="security"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Security
        </TabsTrigger>
        <TabsTrigger
          value="notifications"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Notifications
        </TabsTrigger>
        <TabsTrigger
          value="branches"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Branches
        </TabsTrigger>
        <TabsTrigger
          value="education"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Education System
        </TabsTrigger>
        <TabsTrigger
          value="games"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Game Controls
        </TabsTrigger>
        <TabsTrigger
          value="additional"
          className="data-[state=active]:bg-white data-[state=active]:text-primary data-[state=active]:border-b-2 data-[state=active]:border-primary"
        >
          Additional
        </TabsTrigger>
      </TabsList>

      <TabsContent value="account" className="mt-6">
        <AccountSettingsTab />
      </TabsContent>

      <TabsContent value="security" className="mt-6">
        <LoginSecurityTab />
      </TabsContent>

      <TabsContent value="notifications" className="mt-6">
        <NotificationsTab />
      </TabsContent>

      <TabsContent value="branches" className="mt-6">
        <BranchesTab />
      </TabsContent>

      <TabsContent value="education" className="mt-6">
        <EducationSystemTab />
      </TabsContent>

      <TabsContent value="games" className="mt-6">
        <GameControlsTab />
      </TabsContent>

      <TabsContent value="additional" className="mt-6">
        <AdditionalSettingsTab />
      </TabsContent>
    </Tabs>
  )
}
